import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecografia-general',
  templateUrl: './ecografia-general.component.html',
  styleUrls: ['./ecografia-general.component.css']
})
export class EcografiaGeneralComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
